import React from "react";
import "../styles/functionalites.css";

const Functionalites = (props) => {
  return (
    <>
      {true ? (
        <>
          <div className="mainContainerFunctionalites">
            <div
              style={{
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                gap: "5px",
              }}
            >
              {props.user.team.includes("2") &&
              props.checkPermissions("rozprawaDodawanie") ? (
                <button
                  value="add_date"
                  onClick={props.handleOptionChange}
                  className="colFunctionalites"
                >
                  DODAJ ROZPRAWĘ
                </button>
              ) : (
                ""
              )}

              {props.user.team.includes("2") &&
              props.checkPermissions("zadanieDodawanie") ? (
                <button
                  value="add_task"
                  onClick={props.handleOptionChange}
                  className="colFunctionalites"
                >
                  DODAJ ZADANIE
                </button>
              ) : (
                ""
              )}

              {props.user.team.includes("2") &&
              props.checkPermissions("platnosci") ? (
                <button
                  value="calendar"
                  onClick={props.showAddClientContactPopUp}
                  className="colFunctionalites"
                >
                  DODAJ KONTAKT Z KLIENTEM
                </button>
              ) : (
                ""
              )}

              {props.user.team.includes("2") &&
              props.checkPermissions("platnosci") ? (
                <button
                  value="calendar"
                  onClick={props.showAddPaymentsPopUp}
                  className="colFunctionalites"
                >
                  DODAJ PŁATNOŚĆ
                </button>
              ) : (
                ""
              )}

              {props.checkPermissions("dodajSprawe") ? (
                <button
                  value="calendar"
                  onClick={props.showAddClientPopUp}
                  className="colFunctionalites"
                >
                  DODAJ SPRAWĘ
                </button>
              ) : (
                ""
              )}

              {props.checkPermissions("kalendarz") ? (
                <button
                  value="calendar"
                  onClick={props.handleOptionChange}
                  className="colFunctionalites"
                >
                  KALENDARZ
                </button>
              ) : (
                ""
              )}

              {props.user.role === "consultantTele" ? (
                <button
                  value="calendarSell"
                  onClick={props.showSellSystemCalendar}
                  className="colFunctionalites"
                >
                  KALENDARZ
                </button>
              ) : (
                ""
              )}

              {props.checkPermissions("ewidencja") ? (
                <button
                  value="calendar"
                  onClick={props.showClientsPopUp}
                  className="colFunctionalites"
                >
                  EWIDENCJA
                </button>
              ) : (
                ""
              )}

              {props.checkPermissions("urlopy") ? (
                <button
                  value="calendar"
                  onClick={props.showHolidayPopUp}
                  className="colFunctionalites"
                >
                  URLOPY
                </button>
              ) : (
                ""
              )}

              {props.checkPermissions("platnosci") &&
              props.user.allowedClients === "all" ? (
                <button
                  value="calendar"
                  onClick={props.showPaymentsPopUp}
                  className="colFunctionalites"
                >
                  PŁATNOŚCI
                </button>
              ) : (
                ""
              )}

              {props.checkPermissions("wyszukaj") ? (
                <button
                  value="calendar"
                  onClick={props.showSearchPopUp}
                  className="colFunctionalites"
                >
                  WYSZUKAJ
                </button>
              ) : (
                ""
              )}

              {props.checkPermissions("raporty") ? (
                <button
                  value="calendar"
                  onClick={props.showReportPopUp}
                  className="colFunctionalites"
                >
                  RAPORTY
                </button>
              ) : (
                ""
              )}

              {props.checkPermissions("zbiorczoAkceptacjaTerminow") ? (
                <button
                  value="calendar"
                  onClick={props.multiAcceptHearings}
                  className="colFunctionalites"
                >
                  AKCEPTUJ TERMINY
                </button>
              ) : (
                ""
              )}

              {props.checkPermissions("akceptacjaSprawyZb") ? (
                <button
                  value="calendar"
                  onClick={props.showAcceptClients}
                  className="colFunctionalites"
                >
                  AKCEPTUJ SPRAWY
                </button>
              ) : (
                ""
              )}

              {props.user.superAdmin === "1" ? (
                <button
                  value="calendar"
                  onClick={props.showAdminPanel}
                  className="colFunctionalites"
                  id="paneladmi"
                >
                  PANEL ADMINISTRACYJNY
                </button>
              ) : (
                ""
              )}

              {props.user.dostep === "1" && props.user.superAdmin !== "1" ? (
                <button
                  value="calendar"
                  onClick={props.showAdminPanelUA}
                  className="colFunctionalites"
                >
                  PRZYDZIEL DOSTEP
                </button>
              ) : (
                ""
              )}

              <button
                value="calendar"
                onClick={props.showSellSystem}
                className="colFunctionalites"
              >
                KONTAKTY
              </button>

              {props.user.sprzedazZlecSpraweFinish === "1" ? (
                <button
                  value="calendar"
                  onClick={props.showFinishLeads}
                  className="colFunctionalites"
                >
                  ZAŁÓŻ SPRAWĘ
                </button>
              ) : (
                ""
              )}
              {props.user.role !== "consultantTele" &&
              props.user.role !== "consultantTeleSKD" ? (
                <button
                  value="calendar"
                  onClick={props.showConfRoomRes}
                  className="colFunctionalites"
                >
                  REZERWACJA SALI
                </button>
              ) : (
                ""
              )}

              {props.user.materials === "1" ? (
                <button
                  value="calendar"
                  onClick={props.showMaterials}
                  className="colFunctionalites"
                >
                  MATERIAŁY
                </button>
              ) : (
                ""
              )}

              {props.user.postBook === "1" ? (
                <button
                  value="calendar"
                  onClick={props.showPostBook}
                  className="colFunctionalites"
                >
                  KSIĄŻKA NADAWCZA
                </button>
              ) : (
                ""
              )}

              {props.user.superAdmin === "1" ? (
                <button
                  value="calendar"
                  onClick={props.showChecklistReportPopUp}
                  className="colFunctionalites"
                >
                  RAPORT - CHECKLISTA
                </button>
              ) : (
                ""
              )}

              {props.user.devs === "1" ? (
                <button
                  value="calendar"
                  onClick={props.showUndev}
                  className="colFunctionalites"
                >
                  NIEODEBRANE DORĘCZENIA
                </button>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default Functionalites;
